import React, { Component, Fragment } from 'react';
import ConfirmationModal from '../../modals/ConfirmationModal';
import View from './View';

class ManageWrapper extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = { manage: {}, isConfirmationOpen: false };
  }

  handleChange = (_e, { name, value }) => {
    this.setState(({ manage }) => ({ manage: { ...manage, [name]: value } }));
  };

  handleConfirm = test => {
    if (test) {
      this.submit();
    }
    this.setState({ isConfirmationOpen: false });
  };

  handleSubmit() {
    const { manage } = this.state;
    if (manage && manage.status === 'closed') {
      return this.setState({ isConfirmationOpen: true });
    }
    this.submit();
  }

  handleClear = () => this.setState({ manage: {} });

  submit = () => {
    const { manage } = this.state;
    const { selectedTaskIds, refetchTasks, mutate } = this.props;

    mutate({
      variables: {
        input: {
          ...manage,
          tasksIds: selectedTaskIds(),
        },
      },
    })
      .then(() => {
        refetchTasks();
      })
      .catch(error => {
        console.dir(error);
        this.setState({ loading: false });
      });
  };

  render = () => {
    const { isConfirmationOpen, manage } = this.state;
    return (
      <Fragment>
        <ConfirmationModal
          question="Do you really want to close these tasks?"
          isOpen={isConfirmationOpen}
          onConfirmation={this.handleConfirm}
        />
        <View
          {...this.props}
          onChange={this.handleChange}
          onClear={this.handleClear}
          onApply={this.handleSubmit}
          values={manage}
        />
      </Fragment>
    );
  };
}

export default ManageWrapper;



// WEBPACK FOOTER //
// ./src/component/TasksManagerList/ManageMenu/Wrapper.js